export const SCHEDULING_ASSISTANT_USER_APP_DEF_ID = '4886d214-d965-4e97-9f49-51c7a80a345f';
export const SCHEDULING_ASSISTANT_UOU_APP_DEF_ID = 'f5b4ce00-4f7b-4066-a607-0277d16780b8';

// DevCenter component (type=WIX_AI_GATEWAY_CALLBACK) that routes WixAiGateway async
// completions back to orion-harness-poc via the SPI HandleResult callback. The appId
// is SCHEDULING_ASSISTANT_UOU_APP_DEF_ID above.
export const ORION_HARNESS_WIX_AI_GATEWAY_CALLBACK_COMPONENT_ID = '34b09d1f-1e9c-4a9a-8084-aef76c3ecb98';
export const WIX_WHAAAT_METASITE_ID = 'cc119d2c-2d63-4cf0-9531-b07ef0728c91';
export const WIX_WELLNESS_METASITE_ID = 'b1e78495-753d-4301-963d-2a6dec50fb8f';
export const BOOKINGS_APP_DEF_ID = '13d21c63-b5ec-5912-8397-c3a5ddb27a97';
export const BM_STANDALONE_APP_BASE_URL = 'https://manage.wix.com/orion';
export const BM_CONNECT_CALENDAR_SUCCESS_PAGE_URL = `${BM_STANDALONE_APP_BASE_URL}/connect/success`;
export const BM_CONNECT_CALENDAR_FAILURE_PAGE_URL = `${BM_STANDALONE_APP_BASE_URL}/connect/failure`;
export const UOU_CHAT_APP_BASE_URL = 'https://chat.nownia.com';
export const INDIVIDUAL_CONNECT_CALENDAR_SUCCESS_PAGE_URL = `${UOU_CHAT_APP_BASE_URL}/connect/success`;
export const INDIVIDUAL_CONNECT_CALENDAR_FAILURE_PAGE_URL = `${UOU_CHAT_APP_BASE_URL}/connect/failure`;
export const UOU_CHAT_CONNECT_CALENDAR_SUCCESS_PAGE_URL = `${UOU_CHAT_APP_BASE_URL}/connect/success`;
export const UOU_CHAT_CONNECT_CALENDAR_FAILURE_PAGE_URL = `${UOU_CHAT_APP_BASE_URL}/connect/failure`;
export const DEFAULT_ASSISTANT_NAME = 'Orion';
export const STATIC_IMAGE_DOMAIN = 'https://static.wixstatic.com';
export const USER_CONVERSATION_ORIGIN = 'scheduling-assistant';
export const UOU_CONVERSATION_ORIGIN = 'uou-scheduling-assistant';
export const INDIVIDUAL_CONVERSATION_ORIGIN = 'individual-scheduling-assistant';
export const MEETING_INVITATION_SENT_AUTOMATION_ID = '707be516-5a63-435a-b020-53b8e5542eec';
export const MEETING_REMINDERS_AUTOMATION_ID = '707be516-5a63-435a-b020-53b8e5542eec';
export const USER_UNIFIED_ASSISTANT_ID = '1fccd576-9456-47ef-8ff2-a9f040520175';
export const UOU_UNIFIED_ASSISTANT_ID = '816d02ea-0c56-4fe7-8850-fc420383a249';
export const INDIVIDUAL_UNIFIED_ASSISTANT_ID = '5df736a5-c235-4648-8eb1-df868689c9e4';
export const INDIVIDUAL_ONBOARDING_UNIFIED_ASSISTANT_ID = 'cb4b460a-b2cb-41e7-8da1-59f89c07d5fd';
export const INDIVIDUAL_KNOWLEDGE_UNIFIED_ASSISTANT_ID = 'e3af2dde-ae3a-4d5e-bb71-6a17631ac5f7';
export const UOU_SCHEDULING_ASSISTANT_HEADLESS_CLIENT_ID = '76e857b7-b04e-42b6-9e03-dbc1e7bc7b40';
export const ASSISTANT_NAME_CHAR_LIMIT = 15;
export const MAX_ATTACHMENT_SIZE_BYTES = 5 * 1024 * 1024;
export const SEND_MESSAGE_TIME_BUDGET = 360_000;
export const ABORT_MESSAGE_TIME_BUDGET = 30_000;
export const BRAIN_SIMULATION_TIME_BUDGET = 120_000;
export const ORION_MAILBOX_ADDRESS = 'orion@wix.com';
export const INDIVIDUAL_SIMULATION_META_SITE_IDS = ['cce9739c-9ab0-4e26-9930-ffb3800c04b9', '3d33d283-2e47-4b9b-b4dd-4ea76cf0853d'];
export const UOU_ASSISTANT_REFERENCE = {
  type: 'unified-assistant',
  unifiedAssistantId: UOU_UNIFIED_ASSISTANT_ID
};
export const INDIVIDUAL_ASSISTANT_REFERENCE = {
  type: 'unified-assistant',
  unifiedAssistantId: INDIVIDUAL_UNIFIED_ASSISTANT_ID
};
export const ORION_WHATSAPP_WABA_ID = '742949560008212';
export const ORION_WHATSAPP_PHONE_NUMBER_ID = '753186627877106';
export const ORION_WHATSAPP_INBOUND_NUMBER = '15188556881';
export const ORION_SMS_ACCOUNT_ID = '00000000-0000-0000-0000-000000000001';
export const ORION_SMS_INBOUND_NUMBER = '+18888953379';

// Browserbase constants
export const BROWSERBASE_CONSTANTS = {
  STAGEHAND: {
    ENV: 'BROWSERBASE',
    MODEL_NAME: 'claude-3-7-sonnet-latest',
    HEADLESS: true,
    ENABLE_CACHING: true
  },
  SCREENSHOT: {
    TYPE: 'png',
    ENCODING: 'base64'
  }
};
export const FEEDBACK_FORM_ID = '910cc899-42f8-4810-81c9-3681ad488bc8';
export const LANDING_PAGE_WEBSITE_MSID = '70ab3653-f410-455f-a7f6-0e39c48963ab';

// Default categories for task digest
export const DEFAULT_CATEGORIES = ['Work', 'Errands', 'Family', 'Health', 'Social', 'Travel', 'Events & Culture', 'Finance', 'Learning & Enrichment'];
//# sourceMappingURL=index.js.map